import React from "react";
import "./admin.css";

const AnalyticsDashboard = () => {
  return (
    <div className="admin-page">
      <div className="admin-header">
        <div>
          <h1>Analytics Dashboard</h1>
          <p>View system analytics, user activity, and performance metrics</p>
        </div>
      </div>

      <div className="content-stage">
        <div className="stage-text">
          <h2>Coming Soon</h2>
          <p>Analytics and reporting features will be available here.</p>
          <p style={{ marginTop: "16px", fontSize: "14px", opacity: 0.8 }}>
            This dashboard will provide insights into:
          </p>
          <ul style={{ textAlign: "left", marginTop: "12px", lineHeight: "1.8" }}>
            <li>User engagement and activity</li>
            <li>Tracker completion rates</li>
            <li>Training progress metrics</li>
            <li>System performance stats</li>
            <li>User growth and retention</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard;
